import axios from "axios";

axios.defaults.baseURL = "https://amailo-backend.vercel.app/"
  
